import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Machine from "../screens/machine";
import Tool from "../screens/tool";
import Login from "../screens/login";
import Scanner from "../screens/scanner";
import SendMachine from "../screens/send";
import SendTool from "../screens/send_tool";
import UpdateMachine from "../screens/update";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import "./index.css";

export default function(props) {
  const routes = location => (
    <Switch location={location}>
      <Route path="/scanner" component={Scanner} />
      {/* <Route
        path="/machine/:id/send/:courier?/:courierNumber?"
        component={SendMachine}
      /> */}
      <Route
        path="/machine/:id/send/:courier?/:courierNumber?"
        component={SendMachine}
      />
      <Route
        path="/tool/:id/send/:courier?/:courierNumber?"
        component={SendTool}
      />
      <Route path="/machine/:id/update/" component={UpdateMachine} />
      <Route path="/machine/:barcode?" component={Machine} />
      <Route path="/tool/:barcode?" component={Tool} />
      <Route exact path="/login" component={Login} />
      <Route path="/" component={() => <Redirect to="/login" />} />
    </Switch>
  );
  return (
    <BrowserRouter>
      <Route
        render={({ location }) => (
          <TransitionGroup>
            <CSSTransition
              key={location.key}
              classNames={location.pathname == '/tool' || location.pathname == '/machine' ? "fade" : "background"}
              timeout={location.pathname == '/tool' || location.pathname == '/machine' ? 0 : 300}
            >
              {routes(location)}
            </CSSTransition>
          </TransitionGroup>
        )}
      />
    </BrowserRouter>
  );
}



// WEBPACK FOOTER //
// ./src/router/index.js